import AboutPage from "./AboutPage";

export const AboutPageConfig = {
  routes: [
    {
      path: "/pages/about",
      exact: true,
      component: AboutPage
    }
  ]
};
